import { render, staticRenderFns } from "./introduceDialog.vue?vue&type=template&id=215ea7a3&scoped=true&"
import script from "./introduceDialog.vue?vue&type=script&lang=js&"
export * from "./introduceDialog.vue?vue&type=script&lang=js&"
import style0 from "./introduceDialog.vue?vue&type=style&index=0&id=215ea7a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215ea7a3",
  null
  
)

export default component.exports